export const SageStatus = {
  CONNECTED: 'SAGE is connected',
  DISCONNECTED: 'SAGE is not connected',
};
